export const VendorAuditQuestionnaireInfo: any = [
  {
    id: 1,
    questions: [
      {
        id: 1,
        question: "Is This Part Of FSVP 1 , FSVP 2 Or Anything Else?",
        answer: "fsvp1",
        note: false,
        options: [
          { label: "FSVP 1", value: "fsvp1" },
          { label: "FSVP 2", value: "fsvp2" },
          { label: "None", value: "none" },
        ],
        isMandatory: false,
      },
      {
        id: 2,
        question:
          "Recalls, or Market Withdrawal: Has the vendor undergone a recall, or withdrawal within past 5 years? if so, provide the details of the recall or withdrawal.",
        answer: "no",
        note: true,
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
          { label: "N/A", value: "N/A" },
        ],
        isMandatory: true,
      },
      {
        id: 3,
        question:
          "Warning Latter Search: Has the vendor received a warning letter within past 5 years? if so, provide the details of the warning letter.",
        answer: "no",
        note: true,
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
          { label: "N/A", value: "N/A" },
        ],
        isMandatory: true,
      },
      {
        id: 4,
        question:
          "Import Alert Search/Import Refusal Report: Has the vendor received an import refusal or import alert within 5 years? if so, provide details of the import refusal or import alert.",
        answer: "no",
        note: true,
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
          { label: "N/A", value: "N/A" },
        ],
        isMandatory: true,
      },
      {
        id: 5,
        question:
          "FSMA Supplier Evaluation Resource and Enforcement search: Has the vendor undergone a food compliance enforcement action? (Inspection Classifications of Voluntary Action Indicated (VAI) or Official Action Indicated (OAI) Seizures, Injunctions, etc) within the past 5 years? if so, provide the details of the enforcement actions.",
        answer: "no",
        note: true,
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
          { label: "N/A", value: "N/A" },
        ],
        isMandatory: true,
      },
      {
        id: 6,
        question: "Review of Regulatory Performance Verification Activity:",
        answer: "yes",
        note: true,
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
          { label: "N/A", value: "N/A" },
        ],
        isMandatory: true,
      },
      {
        id: 7,
        question: "Review of Third-Party Onsite Audit Verification Activity:",
        answer: "yes",
        note: true,
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
          { label: "N/A", value: "N/A" },
        ],
        isMandatory: true,
      },
      {
        id: 8,
        question:
          "Have there been any regulatory action associated with production lines that manufacture Trader Joe's product?",
        answer: "n/a",
        note: true,
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
          { label: "N/A", value: "N/A" },
        ],
        isMandatory: true,
      },
      {
        id: 9,
        question:
          "In the last 3 years, have any finished products or food contact surfaces tested positive for pathogens?",
        answer: "n/a",
        note: true,
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
          { label: "N/A", value: "N/A" },
        ],
        isMandatory: true,
      },
      {
        id: 10,
        question:
          "Have there been any changes associated with procedure, processes or practices associated with food safety?",
        answer: "n/a",
        note: true,
        options: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
          { label: "N/A", value: "N/A" },
        ],
        isMandatory: true,
      },
    ],
  },
];
